import React from 'react';

const Notfound = () => {
    return (
        <div>
            <h3>error..!! This is page not found</h3>
        </div>
    );
};

export default Notfound;
